import React, { useCallback, useEffect, useState } from 'react';
import delay from 'lodash/delay';
import { useSelector } from 'react-redux';
import { getProductCardLabels } from '@yme/pdp-components/ProductCard';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { PAYEVER_LOAD_TIMEOUT, PAYEVER_SDK, PAYEVER_WIDGET_CLASS } from './constants';
import { PayeverContainerStyled, SeparatorStyled } from './styled';
const scriptAlreadyExists = () => document.querySelector(`script#${PAYEVER_SDK}`) !== null;
export const PayeverCalculator = ({ payeverCalculatorConfig, amount, icon, textPrompt, isAvailableWidget, children, }) => {
    const { widgetId, checkoutId, businessId, type = 'dropdownCalculator', reference = 'widget', scriptSrc = '', } = payeverCalculatorConfig || {};
    const { productCard_santanderPayInInstalments_title: santanderSeparatorLabel } = useSelector(getProductCardLabels);
    const [hasLoaded, setHasLoaded] = useState(false);
    const appendPayeverScript = useCallback(() => {
        const script = document.createElement('script');
        script.id = PAYEVER_SDK;
        script.src = scriptSrc;
        script.async = true;
        script.onload = () => setHasLoaded(true);
        script.onerror = (error) => {
            console.error(error);
        };
        document.head.append(script);
    }, [scriptSrc]);
    const initPayeverWidget = useCallback(() => {
        window?.PayeverPaymentWidgetLoader?.init(`.${PAYEVER_WIDGET_CLASS}`);
    }, []);
    const refCalculator = useCallback((node) => {
        if (node !== null) {
            initPayeverWidget();
        }
    }, [initPayeverWidget]);
    useEffect(() => {
        if (scriptAlreadyExists() || hasLoaded) {
            delay(() => initPayeverWidget(), PAYEVER_LOAD_TIMEOUT);
        }
        else {
            appendPayeverScript();
        }
    }, [appendPayeverScript, hasLoaded, initPayeverWidget]);
    if (!scriptSrc) {
        return null;
    }
    return (React.createElement(React.Fragment, null, isAvailableWidget && (React.createElement(React.Fragment, null,
        React.createElement(SeparatorStyled, { text: santanderSeparatorLabel }),
        React.createElement(PayeverContainerStyled, { ref: refCalculator, className: PAYEVER_WIDGET_CLASS, "data-widgetid": widgetId, "data-checkoutid": checkoutId, "data-business": businessId, "data-type": type, "data-reference": reference, "data-scriptsrc": scriptSrc, "data-amount": amount }),
        React.createElement(FlexWrapper, { alignItems: "center", flexDirection: "row", gap: INDENT.xxxs },
            icon && icon,
            textPrompt && React.createElement(RegularTextLevel3, null, textPrompt),
            children)))));
};
